import CheckboxExample from "./examples/Checkbox.Example";
import CheckboxesStackedExample from "./examples/CheckboxesStacked.Example";
import TriStateCheckboxExample from "./examples/TriStateCheckbox.Example";

export default [
    {
        title: "Basic checkbox",
        component: CheckboxExample,
        code: require("!raw-loader!./examples/Checkbox.Example.tsx")
    },
    {
        title: "Basic checkboxes stacked",
        component: CheckboxesStackedExample,
        code: require("!raw-loader!./examples/CheckboxesStacked.Example.tsx")
    },
    {
        title: "Tri-state checkbox",
        component: TriStateCheckboxExample,
        code: require("!raw-loader!./examples/TriStateCheckbox.Example.tsx")
    }
];
